/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EChatType } from "../types/EChatType.ts";

/**
 * @description 1 = UseArenaChat | 2 = Manual | 3 = UseGetStream | 4 = UseDeadSimpleChat | 5 = UseMoveChat |
 */
export const eChatTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = UseArenaChat | 2 = Manual | 3 = UseGetStream | 4 = UseDeadSimpleChat | 5 = UseMoveChat | ",
  ) as unknown as ToZod<EChatType>;
